import { useClipboard } from '@chakra-ui/react';
import { useSnackbar } from 'ui-components';
import {
  SNACKBAR_ERROR_GENERIC_OPTIONS,
  SNACKBAR_GENERIC_OPTIONS,
} from '~/constants';

export const useCopyMKLink = (id: string) => {
  const snackbar = useSnackbar();

  const { onCopy } = useClipboard(
    `${window.location.origin}/shared/media-kits/${id}`,
  );

  const handleCopy = async () => {
    try {
      await onCopy();
      snackbar.success({
        ...SNACKBAR_GENERIC_OPTIONS,
        description: 'Link successfully copied',
      });
    } catch (error) {
      snackbar.error({
        ...SNACKBAR_ERROR_GENERIC_OPTIONS,
        description: 'Failed to copy link',
      });
    }
  };

  return { copyMkLink: handleCopy };
};
